export const DEFAULT_COLUMN_SET_TYPE   = 'Default'
export const USER_COLUMN_SET_TYPE      = 'User'
export const IMPORT_COLUMN_SET_TYPE    = 'Import'
export const DEFAULT_COLUMN_WIDTH_SPACING = 55
export const DEFAULT_COLUMN_WIDTH_CHAR = 6.5
export const DEFAULT_COLUMN_WIDTH_MAPS_TO = 40